import styled from 'styled-components';
import { layout } from 'src/components/base';

export const CategoryInformation = styled.div`
  color: ${({ theme }) => theme.text.tertiary};
  font-size: ${layout.fontSizes.base.desktop.rem};
  margin-top: ${layout.measurements.spacing125};
`;

export const CategoryInformationPTag = styled.p`
  margin-bottom: 0;
`;
